import { HttpInterceptorFn, HttpResponse } from '@angular/common/http';
import { of, tap } from 'rxjs';

const CACHEABLE_ROUTE_FRAGMENTS = [
  '/Countries',
  '/BusinessUnits',
  '/LocalProductGroupUnits',
];

const responseCache = new Map<string, HttpResponse<unknown>>();

export const cacheInterceptor: HttpInterceptorFn = (req, next) => {
  if (
    req.method !== 'GET' ||
    !CACHEABLE_ROUTE_FRAGMENTS.some(fragment => req.url.includes(fragment))
  ) {
    return next(req);
  }

  const cacheKey = req.urlWithParams;
  const cached = responseCache.get(cacheKey);
  if (cached) {
    return of(cached.clone());
  }

  return next(req).pipe(
    tap(event => {
      if (event instanceof HttpResponse) {
        responseCache.set(cacheKey, event);
      }
    }),
  );
};
